module.exports = __webpack_public_path__ + "img/MobileImage5.febf9410.png";